import { render } from "./Solution.vue?vue&type=template&id=242e075c&scoped=true"
import script from "./Solution.vue?vue&type=script&lang=js"
export * from "./Solution.vue?vue&type=script&lang=js"

import "./Solution.vue?vue&type=style&index=0&id=242e075c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-242e075c"

export default script